import {
  Component,
  OnInit,
  Compiler,
  AfterViewInit,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormValidatorService } from '../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../shared/validators';
import { BankAccountTable, Bank } from '../../../../seller';
import { PasswordConfirmComponent } from '../../../../../../shared/components/password-confirm/password-confirm.component';
import { GetListOfBanksService } from '../../../services/get-list-of-banks.service';
import { AddBankAccountService } from '../../../services/add-bank-account.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { CONSTANT_CUSTOMER_SUPPORT_INFO } from 'src/app/shared/ConstantCustomerSupportInfo';
import {
  BankAccountAddedNotifierService, NewBankAccountResponse
} from 'src/app/dashboard/seller/my-account/components/new-contract-page/BankAccountAddedNotifier.service';
import { ListBankAccountsService } from '../../../services/list-accounts.service';
import { ContractFormStatusService } from 'src/app/shared/services/contract-form-status.service';
@Component({
  selector: 'app-bank-fields',
  templateUrl: './bank-fields.component.html',
  styleUrls: ['./bank-fields.component.scss'],
})
export class BankFieldsComponent implements OnInit, AfterViewInit {
  bankAccountForm!: FormGroup;
  formValidator: FormValidatorService = new FormValidatorService();
  banks: Bank[] = [];
  bankBranches: any[] = [];
  accounts: BankAccountTable[] = [];
  totalNumberOfRecords: number = 0;
  bankAccountReportData: any[] = [];
  IBANPattern = '^[A-Za-z0-9]+$';
  charcterPattern = '(^[a-zA-Z ]+$)|(^[\u0621-\u064A ]+$)';
  reportName: string = '';
  buttonsDisabled: boolean = false;
  accountTypesTranslated = {
    MobileWallet: {
      name: 'Sellers.Products.MobileWallet',
      value: 'Mobile Wallet',
    },
    BankAccount: {
      name: 'Sellers.Products.BankAccount',
      value: 'Bank Account',
    },
  };
  @Input() disableMode: boolean;

  constructor(
    private addAccountService: AddBankAccountService,
    private listBanksService: GetListOfBanksService,
    private bankAccountAddedNotifier: BankAccountAddedNotifierService,
    private getBankAccountDat: ListBankAccountsService,
    public dialog: MatDialog,
    private compiler: Compiler,
    private translate: TranslateService,
    private contractFormStatusService: ContractFormStatusService
  ) {
    this.compiler.clearCache();
  }
  loading = false;
  isBank = true;
  async ngOnInit() {
    try {
      this.banks = await this.listBanksService.make();
    } catch (err) {
      this.banks = [];
    }
    this.bankAccountForm = this.formValidator.createForm([
      {
        fieldName: 'bank_type',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'bank_id',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'BranchId',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'holder_name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.pattern(this.charcterPattern),
            message: '',
          },
        ],
      },
      {
        fieldName: 'account_number',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.maxLength(32),
            message: '',
          },
          {
            validatorFn: Validators.pattern(this.IBANPattern),
            message: '',
          },
        ],
      },
    ]);
    if (this.disableMode) {
      await this.checkExistingValues();
    }
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }
  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        bank_id: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Bank',
            fieldAr: 'إسم البنك',
          }),
        },
        bank_type: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Account Type',
            fieldAr: 'نوع الحساب',
          }),
        },
        BranchId: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Branch Name',
            fieldAr: 'إسم الفرع',
          }),
        },
        holder_name: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Account holder name',
            fieldAr: 'اسم صاحب الحساب',
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Account holder name',
            fieldAr: 'اسم صاحب الحساب',
          }),
        },
        account_number: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'this field',
            fieldAr: 'مدخل',
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'this field',
            fieldAr: 'مدخل',
            value: 32,
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'this field',
            fieldAr: 'مدخل',
          }),
        },
      };
    });
  }
  async checkExistingValues() {
    const bankAccounts = await this.getBankAccountDat.make();
    if (bankAccounts.result.length >= 1) {
      const userBankAccountData: BankAccount = bankAccounts.result[0];

      this.onBankTypeSelection({ target: { value: userBankAccountData.type } });
      this.bankAccountForm.controls['holder_name'].setValue(
        userBankAccountData.holder_name
      );
      this.bankAccountForm.controls['account_number'].setValue(
        userBankAccountData.account_number
      );

      this.bankAccountForm.controls['bank_type'].setValue(userBankAccountData.type);
      if (userBankAccountData.type == 'Bank Account') {
        const bank = this.banks.find((res) => {
          return res.bank_name == userBankAccountData.bank_name;
        });
        const branch = bank.Branches.find((res) => {
          return (
            res.english_branch_name == userBankAccountData.english_branch_name
          );
        });
        this.bankBranches = bank.Branches;
        this.bankAccountForm.controls['bank_id'].setValue(bank.id);
        this.bankAccountForm.controls['BranchId'].setValue(branch.id);
      }
      if (userBankAccountData.status == 'Accepted') {
        this.contractFormStatusService.setContractFormStatus(0, true);
        this.bankAccountForm.disable();
        this.buttonsDisabled = true;
        this.bankAccountAddedNotifier.pushStatusNotification({
          account_number:userBankAccountData.account_number,
          holder_name: userBankAccountData.holder_name,
          arabic_branch_name: userBankAccountData.arabic_branch_name,
          arabic_bank_name: userBankAccountData.arabic_bank_name
        });
      }
    }
  }
  async AddBankAccount() {
    try {
      const confirmPasswordData = new MatDialogConfig();
      confirmPasswordData.data = {
        showOtp: false
      }
      const dialogRef = this.dialog.open(PasswordConfirmComponent, confirmPasswordData);
      const result = await dialogRef.afterClosed().toPromise();
      if (!result?.status) {
        return;
      }
      const bankAccountFormValues = {
        holder_name: this.bankAccountForm.value.holder_name,
        account_number: this.bankAccountForm.value.account_number,
        BranchId: this.bankAccountForm.value.BranchId,
        type: this.bankAccountForm.value.bank_type,
      };

      this.addAccountService.setParams(bankAccountFormValues);
      const newAccount = await this.addAccountService.make();
      if (newAccount.status != 'Accepted') this.pendingAlert();
      else this.acceptedAlert();
      const newAccountResult: NewBankAccountResponse = {
        ...newAccount,
        arabic_branch_name: newAccount.arabic_branch_name,
      };
      this.bankAccountAddedNotifier.pushStatusNotification(newAccountResult);
      this.contractFormStatusService.setContractFormStatus(0, true);
      if (this.disableMode) {
        this.bankAccountForm.disable();
        this.buttonsDisabled = true;
      }else{
        this.bankAccountForm.reset();
      }
    } catch (err) {
      console.log('error >>>>' + err);
    }
  }
  onBankSelection(event: any) {
    const bankBranchesTemp = this.banks.filter(
      (el) => el.id == event.target.value
    );
    const myOrderedArray = bankBranchesTemp[0].Branches;
    this.bankBranches = myOrderedArray;
    this.bankAccountForm.controls['BranchId'].setValue(myOrderedArray[0].id);
  }
  onBankTypeSelection(event: any) {
    if (event.target.value == this.accountTypesTranslated.BankAccount.value) {
      this.isBank = true;
      this.formValidator.addValidation('bank_id', 'required');
      this.formValidator.addValidation('BranchId', 'required');
    } else {
      this.isBank = false;
      this.formValidator.clearValidation('bank_id');
      this.formValidator.clearValidation('BranchId');
    }
  }
  acceptedAlert() {
    Swal.fire({
      icon: 'success',
      title: 'Your bank account is Accepted',
      showConfirmButton: false,
      timer: 3000,
    });
  }
  pendingAlert() {
    Swal.fire({
      icon: 'info',
      html: `Your new bank account has been sent for review and will be added soon,
        for inquiries please contact support at ${CONSTANT_CUSTOMER_SUPPORT_INFO.phone}`,
      focusConfirm: false,
      confirmButtonText: 'Confirm',
      timer: 10000,
    });
  }
}
interface BankAccount {
  BusinessId: number;
  account_number: string;
  arabic_bank_name: string;
  arabic_branch_name: string;
  bank_name: string;
  english_branch_name: string;
  holder_name: string;
  id: number;
  type: 'Mobile Wallet' | 'Bank Account';
  status: 'Accepted' | 'Pending';
}
